import React, { useEffect, useState } from "react";
import "../styles/Ecosistemas.css";
import { EcosistemasCards } from "./EcosistemasCards";
import AliceCarousel from "react-alice-carousel";
import { ButtonNext, ButtonPrevious } from "../../../../assets/icons/Icons";

export const Ecosistema = ({ ecosistemas }) => {
  const [ecosistema, setEcosistema] = useState();

  const responsive = {
    320: {
      items: 1,
    },
    576: {
      items: 1,
    },
    768: {
      items: 1,
      itemsFit: "contain",
    },
    1024: {
      items: 2,
      itemsFit: "contain",
    },
    1200: {
      items: 3,
      itemsFit: "contain",
    },
    1400: {
      items: 3,
      itemsFit: "contain",
    },
    1600: {
      items: 4,
      itemsFit: "contain",
    },
    1800: {
      items: 4,
      itemsFit: "contain",
    },
  };

  useEffect(() => {
    if (ecosistemas?.length < 1 || ecosistemas === undefined) return;
    let arregloEcosistema = [];
    ecosistemas?.forEach((element) => {
      arregloEcosistema.push(<EcosistemasCards ecosistema={element} />);
    });
    setEcosistema(arregloEcosistema);
  }, [ecosistemas]);

  return (
    <>
      <div id="ecosistemas" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <div className="banner__ecosistemas">
          <h2>Tus beneficios</h2>
          <p>
            Tu seguro viene acompañado de <b className="bold" style={{fontFamily: "var(--fuente-bold)"}}>Vive tu Seguro</b>, una plataforma que te permitirá acceder a nuestra <br className="d-none d-lg-block" /> oferta específica de beneficios desde el día uno de inicio de vigencia completamente gratis.
          </p>
        </div>
        <div className="carousel__ecosistemas" style={{margin: "0 5%"}}>
          {ecosistema?.length > 0 && (
              <AliceCarousel
              items={ecosistema}
              responsive={responsive}
              centerMode={true}
              disableDotsControls
              renderPrevButton={({ isDisabled }) => {
                return (
                  <>
                    {!isDisabled && (
                      <div className="btn__prev__ecosistemas">
                        <ButtonPrevious />
                      </div>
                    )}
                  </>
                );
              }}
              renderNextButton={({ isDisabled }) => {
                return (
                  <>
                    {!isDisabled && (
                      <div className="btn__next__ecosistemas">
                        <ButtonNext />
                      </div>
                    )}
                  </>
                );
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};
